<template>
  <span class="action-icon-wrapper">
    <Icon :icon="icon" class="action-icon" />
    <Icon v-if="overlayIcon" :icon="overlayIcon" class="action-icon-overlay" />
  </span>
</template>

<script>
export default {
  name: "ActionIcon",
  props: {
    icon: {
      type: String,
      required: true,
    },
    overlayIcon: {
      type: String,
      default: null,
    }
  }
}
</script>

<style scoped lang="scss">
.action-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.action-icon {
  font-size: 1.2rem;
}

.action-icon-overlay {
  position: absolute;
  right: -0.2rem;
  bottom: -0.15rem;
  font-size: 0.7rem;
  background: #fff;
  border-radius: 999px;
  padding: 0.05rem;
}
</style>
